import React from "react";
import {Icon, makeStyles, Paper} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'grid',
        gridTemplateColumns: "auto auto",
        justifyContent: 'center',
        gap: 50,
        backgroundColor: '#f7f7f7',
        padding: 30
    },
    item: {
        width: 300, height: 300, display: 'flex', justifyContent: 'center', alignItems: 'center',
        flexDirection: 'column',
        '&:hover': {
            border: '1px solid lightgray'
        }
    },
    itemSelected: {
        border: `1px solid ${theme.palette.primary.main} !important`,
    }
}))
const CreationTypeSelection = ({selectedType, setSelectedType}) => {
    const classes = useStyles();
    return (
        <div>
            <Typography align={'center'} variant={"h5"} style={{padding: '15px 0'}}>
                How do you want to start?
            </Typography>
            <div className={classes.container}>
                <Paper
                    onClick={() => setSelectedType('scratch')}
                    className={clsx(
                        classes.item, {[classes.itemSelected]: selectedType === 'scratch'})}
                >
                    <Icon style={{color: "#bebebe", fontSize: 60}} fontSize={"large"}>
                        create_new_folder
                    </Icon>
                    <Typography style={{paddingTop: 15}}>From scratch</Typography>
                </Paper>
                <Paper
                    onClick={() => setSelectedType('template')}
                    className={clsx(classes.item, {[classes.itemSelected]: selectedType === 'template'})}
                >
                    <Icon style={{color: "#bebebe", fontSize: 60}} fontSize={"large"}>
                        description
                    </Icon>
                    <Typography style={{paddingTop: 15}}>From App Template</Typography>
                </Paper>
            </div>
        </div>
    )
}
export default CreationTypeSelection